import { candleParser } from '../candleParser';

/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645479057558,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"rightDirectionPct":0.0,"retracePct":0.6,"candleDuration":1,"timeUnit":"MINUTES","candle":{"high"101,"low":99,"open":100,"close":100,"candleSymbol":"XYZ","candleStartTimeStamp":1645479058247,"duration":"1min"}},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"GREEN_TO_RED_CANDLES","symbol":"XYZ"},
	"date": "2022-02-21T16:30:58.302-0500",
	"timestamp": "1645479058304"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) timeUnit
 * 3) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 * 4) rightDirectionPct
 * 5) retracePct
 */
export function greenToRedCandlesParser(pluginTemplate) {
  const parsedObject = {
    rightDirectionPct: null,
    retracePct: null,
    candleDuration: null,
    timeUnit: null,
    candle: null,
  };
  if (pluginTemplate) {
    parsedObject.rightDirectionPct = pluginTemplate.rightDirectionPct;
    parsedObject.retracePct = pluginTemplate.retracePct;
    parsedObject.candleDuration = pluginTemplate.candleDuration;
    parsedObject.timeUnit = pluginTemplate.timeUnit;
    const candle = candleParser(pluginTemplate.candle);
    if (candle) {
      parsedObject.candle = candle;
    }
  }
  return parsedObject;
}
